import { PushNotifications } from '@capacitor/push-notifications';

export const initAndroidPushRegistration = async () => {
  let permStatus = await PushNotifications.checkPermissions();

  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions();
  }

  if (permStatus.receive !== 'granted') {
    console.log('Push permission not granted');
    return;
  }

  PushNotifications.addListener('registration', (token) => {
    console.log('SOLOWISE_PUSH_TOKEN', token.value);
    localStorage.setItem('pushToken', token.value)
  });

  PushNotifications.addListener('registrationError', (err) => {
    console.error('SOLOWISE_PUSH_ERROR', err);
  });

  await PushNotifications.register();
};